import { render } from "./RadarChart.vue?vue&type=template&id=33c7c4f7&scoped=true"
import script from "./RadarChart.vue?vue&type=script&lang=js"
export * from "./RadarChart.vue?vue&type=script&lang=js"

import "./RadarChart.vue?vue&type=style&index=0&id=33c7c4f7&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c7c4f7"]])

export default __exports__